export const subscribe = (eventName: string, listener: EventListener) => {
  document.addEventListener(eventName, listener);
};

export const unsubscribe = (eventName: string, listener: EventListener) => {
  document.removeEventListener(eventName, listener);
};
export const publish = (eventName: string, data: string) => {
  const event = new CustomEvent<string>(eventName, { detail: data });
  document.dispatchEvent(event);
};
